/**
 * @description 字典
 * @author zhijie.huang
 * @date 2018/9/19
 */
import Logic from './logic-base'

const DIC_LANG = 'zh-CN'
const dicBiz = new Logic()

dicBiz.DICTIONARY_NAME = {
  CODE: {
    'hostLevel': 'ops_host_level',
    'alarmType': 'ops_resource_type',
    'alarmLevel': 'ops_alarm_level',
    'accidentType': 'accidenttype',
    'groupType': 'grouptype',
    'versionType': 'versiontype',
    'influenceScope': 'influencescope',
    'hostType': 'ops_host_type',
    'hostStatus': 'ops_status_type',
    'hostSystem': 'ops_system_type',
    'hostSystemVersion': 'ops_sysversion_type',
    'hostEnvironment': 'ops_evi_type',
    'hostNetCard': 'ops_nic_type',
    'ITDeviceType': 'itdevtype',
    'format': 'format',
    'logTaskStatus': 'logTaskStatus',
    'logDLStatus': 'logDLStatus',
    'logUploadStatus': 'logUploadStatus',
    'dateType': 'datetype',
    'zabbixStatus': 'ops_zabbix_status',
    'modelType': 'modeltype',
    'logLevel': 'logLevel',
    'chartType': 'chartType',
    'serverType': 'servertype',
    'topicType': 'topictype',
    'triggertype': 'triggertype',
    'dataType': 'dataType',
    'unitType': 'unitType',
    'vauleType': 'vauleType',
    'timerTpye': 'timerType',
    'dialRequestType': 'requestType',
    'effectLevel': 'effectLevel',
    'problemSource': 'problemSource',
    'siteType': 'siteType',
    'intervalType': 'intervalType',
    'quicktimetype': 'quicktimetype',
    'relaseStatus': 'relaseStatus',
    'kpiType': 'kpiType',
    'alarmRule': 'alarmRule',
    'alarmCountType': 'alarmCountType',
    'ops_status_type': 'ops_status_type',
    'categoryType': 'categoryType',
    'remoteconfig': 'remoteconfig',
    'monitorlogType': 'monitorlogType',
    'envType': 'envType',
    'deliverystatus': 'deliverystatus',
    'scriptType': 'scriptType',
    'errorProcessType': 'errorProcessType',
    'osType': 'osType',
    'agentType': 'agentType',
    'appPackageType': 'appPackageType',
    'commandType': 'commandType',
    'formatType': 'formatType',
    'processStatus': 'processStatus',
    'scriptExecuteType': 'scriptExecuteType',
    'resourcemodel': 'resourcemodel',
    'authtype': 'authtype',
    'envauthtype': 'envauthtype',
    'accidentStatus': 'accidentStatus',
    'databaseType': 'databaseType',
    'valueType': 'vauleType',
    'checkReportType': 'checkReportType',
    'hosttype2': 'hosttype',
    'workflowOrderStatus': 'workflowOrderStatus',
    'businessType': 'businessType',
    'versiontype': 'versiontype',
    'workflowOperationType': 'workflowOperationType',
    'orderType': 'orderType',
    'zabbix_alarm_level': 'zabbix_alarm_level',
    'route_strategy_type': 'route_strategy_type',
    'tag_status': 'tag_status',
    'tag_operate_type': 'tag_operate_type',
    'timeunittype': 'timeunittype',
    'riskleveltype': 'riskleveltype',
    'recordmoduletype': 'recordmoduletype',
    'projectgrouptype': 'projectgrouptype',
    'businessmoduletype': 'businessmoduletype',
    'credentialstype': 'credentialstype',
    'itemmoduletype': 'itemmoduletype',
    'systemmoduletype': 'systemmoduletype',
    'rulemoduletype': 'rulemoduletype',
    'ruletypemoduletype': 'ruletypemoduletype',
    'resourcemoduletype': 'resourcemoduletype',
    'resultmoduletype': 'resultmoduletype',
    'alarm_continue_time': 'alarm_continue_time',
    'alarmProcessResult': 'ops_alarm_process_result',
    'continue_time': 'continue_time',
  }
}

/**
 * Created by zhijie.huang on 2018/08/21.
 * 查询方法
 * @param {*} data ajax请求参数
 * @param {*} key 字典的key
 */
function doSearch(data, key) {
  return new Promise((resolve, reject) => {
    dicBiz.ajax(data, true).then((d) => {
      try {
        const res = {}
        let arr = d.dataList

        if (d && d instanceof Array) {
          arr = d
        }

        arr.map((item) => {
          res[item[key]] = key === 'appName' ? item[key] : item.desc
        })

        resolve(res)
      } catch (err) {
        reject(err)
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * Created by zhijie.huang on 2018/08/21.
 * 查询appGroup字典值
 * @return {Promise} promise对象
 */
function _searchAppGroupDictionary() {
  return doSearch({
    ...dicBiz.REQUEST_OPT.appManager.findAllGroup
  }, 'name')
}

dicBiz.searchDictionaryByCode = function (code, flag = false) {
  const data = {
    language: DIC_LANG,
    dicCode: flag === false ? this.DICTIONARY_NAME.CODE[code] : code
  }

  if (code === 'groupType') {
    return _searchAppGroupDictionary()
  } else {
    return doSearch({
      ...dicBiz.REQUEST_OPT.dictionary.queryByCode,
      data
    }, 'code')
  }
}

dicBiz.searchAppByGroupName = function (siteCode, group) {
  return doSearch({
    ...dicBiz.REQUEST_OPT.appManager.findAppByGroup,
    data: {
      siteCode: siteCode,
      groupName: group
    }
  }, 'appName')
}

dicBiz.searchGroupBySiteCode = function (siteCode) {
  return doSearch({
    ...dicBiz.REQUEST_OPT.appManager.findAllGroup,
    data: {
      siteCode: siteCode
    }
  }, 'name')
}

export default dicBiz
